import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Globalize } from '@mescius/wijmo'
import Workflow from './Workflow'
import LongText from '../element/LongText'
import ErrorBoundary from '../ErrorBoundary'

function getUsersGroup (approvers) {
  const usersGroup = [new Map(), new Map()]
  approvers.forEach(approver => {
    const user = approver.user
    const users = usersGroup[user.is_manager]
    users.set(user.id, user)
  })

  return usersGroup.map(users => Array.from(users.values()))
}

function getApproversArray (approvers) {
  const levelMap = approvers
    .reduce((m, current, i, src) => {
      if (!m.has(current.level)) {
        m.set(current.level, [])
      }
      current.user.isApproved = current.is_approved
      m.get(current.level).push(current.user)
      return m
    }, new Map())
  return Array.from(levelMap.keys()).sort().map((key) => levelMap.get(key))
}

export default function WorkflowProgress (props) {
  const workflow = props.workflow
  const usersGroup = useRef(getUsersGroup(workflow.all_approvers))
  const approversArray = useRef(getApproversArray(workflow.all_approvers))

  useEffect(() => {
  }, [])

  function historyDescription (history) {
    switch (history.status) {
      case 0:
        return (
          <div>{`${history.approver.user.name}さんが`}<b>承認</b>しました。</div>
        )
      case 1:
        return (
          <div>{`${history.approver.user.name}さんが`}<b>{`${history.return_target.user.name}さんに差戻し`}</b>ました。</div>
        )
      case 2:
        return (
          <div>{`${history.approver.user.name}さんが`}<b>申請者に差戻し</b>ました。</div>
        )
      case 3:
        return (
          <div>申請者が<b>再申請</b>しました。</div>
        )
      case 4:
        return (
          <div>{`${history.approver.user.name}さんが`}申請を<b>取り戻し</b>ました。</div>
        )
      default:
        return (
          <div>ERROR</div>
        )
    }
  }

  return (
    <div className="row">
      <div className="col-4">
        {
          Workflow(usersGroup.current[0], usersGroup.current[1], approversArray.current, 'ライセンシー', true, true)
        }
      </div>
      <div className="col-8">
        <div className="card card-theme">
          <div className="card-header">
            <div>承認履歴</div>
          </div>
          <div className="card-body flow-col">
            <ul className="list-group">
              { workflow.histories.map((history) => (
                <li className={`list-group-item list-group-item-${history.status === 0 ? 'primary' : 'danger'}`} key={history.id}>
                  <div className="d-flex justify-content-between">
                    <h5>{historyDescription(history)}</h5>
                    <small className="float-right">{Globalize.format(new Date(history.created_at), 'F')}</small>
                  </div>
                  {history.has_revise ? <b>★変更あり</b> : <></>}
                  {history.approve_comment ? <LongText text={history.approve_comment}></LongText> : <></>}
                  {Object.keys(history.file_url_list).map((key) => (
                    history.file_url_list[key] && (
                      <div key={key}>
                        <a href={history.file_url_list[key]} target='_blank' rel="noreferrer">{history[key] ? history[key].split('/')[1] : 'ファイル名不明'}</a>
                        <br/>
                      </div>
                    )
                  ))}
                </li>
              )) }
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

WorkflowProgress.propTypes = {
  workflow: PropTypes.object
}

$('#workflow-progress').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WorkflowProgress {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
